import React from 'react'
import {Box, Button, Stack, Typography} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {StarOutline} from "@mui/icons-material";
import {useServiceFavorite} from "./hook/useServiceFavorite";
import {removeHtml, truncateStr} from "../Service";
import {useNavigate} from "react-router-dom";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const ServiceItem = props => {

    const {id, title, description, variant, image, variantName, controls, treading, treadingBadge, isFavorite, addMargin} = props
    console.log(addMargin);
    const {addToFavorite, removeFromFavorite} = useServiceFavorite();

    const nav = useNavigate();

    const navigate = () => {
        if (controls.includes('marketplace')) {
            nav(`/item-detail/${id}`);
        } else {
            if (variant === "advice") {
                nav(`/advice/${id}`)
            } else {
                nav(`/service/${variant}/${id}`)
            }
        }

    }

    const {mode} = useDarkMode();

    return <Box className="service-item-container">
        <Stack
            className="service-item"
            data-variant={variant}
            data-treading={treading && treadingBadge ? 'yes':'no'}
            style={{backgroundColor: mode.settings.cardBackgroundColor}}
            sx={{
                ml: {xs : 'auto' , md : 'auto', lg : '0px'},
                mr: {xs : 'auto' , md : 'auto', lg : addMargin ? '34px' : '0px'},
                width: {xs : '310.4px' , md : '330.4px', lg : '330.4px'},
            }}
            gap={'10px'}
        >
            <Box className="service-item__head" sx={{color : mode.settings.textColor6}}>
                <Stack direction={'row'}>
                    <img src={`/assets/icon/${variant}.png`} alt="service" className="service-item__icon"/>
                    <Typography variant="subtitle1" component="span">
                        {(variantName+'').charAt(0).toUpperCase() + (variantName+'').substring(1)}
                    </Typography>
                </Stack>
                {
                    controls.includes('add-to-fav') && isFavorite &&
                    <Button className="btn btn-fav" onClick={() => removeFromFavorite(id, variant) } >
                        <StarIcon role={'img'} aria-label="Enlever des favoris" />
                        <Typography variant={'subtitle5'}>Enlever des favoris</Typography>
                    </Button>
                }
                {
                    controls.includes('add-to-fav') && !isFavorite &&
                    <Button className="btn btn-fav" onClick={ () => addToFavorite(id, variant) }>
                        <StarOutline role={'img'} aria-label="Ajouter dans mes favoris" />
                        <Typography variant={'subtitle5'}>Ajouter aux favoris</Typography>
                    </Button>
                }
            </Box>
            <Box className="service-item__image">
                <Box sx={{
                    backgroundImage: `url(${image}) , url(${process.env.REACT_APP_DEV_HOST}/assets/img/service0.jpg)`,
                    backgroundSize: "cover",
                    width: "100%",
                    borderRadius: "5px",
                    minHeight: "220px"
                }} />
                <a href={`/service/${id}`} className="service-item__img-link" onClick={ e => {
                    e.preventDefault()
                    navigate();
                } } />
            </Box>
            <Box className="service-item__body">
                <Typography  variant="subtitle1" className="service-item__title" color={mode.settings.textColor}>{title}</Typography>
            </Box>
            {
                controls.includes('show-detail') &&
                <Button className="btn btn-see-detail" onClick={ () => navigate() }>
                    <RemoveRedEyeIcon role={'img'} aria-label="Voir le détail du service" />
                    <Typography component="span">Voir le détail</Typography>
                </Button>
            }
        </Stack>
    </Box>
}

ServiceItem.defaultProps = {
    controls: ['add-to-fav', 'show-detail'],
    treadingBadge: false
}

export default ServiceItem
